"use client";
import CustomButton from "atoms/customButton/CustomButton";
import LoadingScreen from "component/LoadingScreen";
import { JWT_TOKEN, ROUTES } from "lib/Constants";
import { handleErrorMessage, setLocalStorageData } from "lib/utils";
import React, { useEffect, useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { auth0Service } from "services/auth0Service";
import { HANDLE_TOKEN } from "store/auth/action.types";
import { setAuth0Loading } from "store/auth/reducer";
import { RootState } from "store/store";

const AuthCallback = () => {
	const [error, setError] = useState<string>("");
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { userDetails, auth0Loading } = useSelector((store: RootState) => store.auth);

	const handleCallback = async () => {
		try {
			const result = await auth0Service.handleRedirectCallback();
			console.log(result, "result");
			const accessToken = (await auth0Service.silentLogin()) as any;
			const user = await auth0Service.getUser();
			const isAuth = await auth0Service.isAuthenticated();
			const token = accessToken?.access_token || accessToken;
			setLocalStorageData(JWT_TOKEN, token);
			console.log("Access Token:", accessToken);
			console.log("User:", user);
			console.log("Is Authenticated:", isAuth);
			dispatch({ type: HANDLE_TOKEN, payload: true });
		} catch (err) {
			console.error("Auth callback error:", err);
			setError(handleErrorMessage(err));
			dispatch(setAuth0Loading(false));
		}
	};

	const handleRedirect = () => {
			navigate(ROUTES.TENANTS)
		// const { email, attributes, userRoles } = profile;
		// // Verify email exists and is verified
		// if (!email || !attributes?.email_verified) {
		// 	// logout logic here
		// 	dispatch({ type: HANDLE_AUTH });
		// 	return;
		// }
		// // Role-based redirects
		// if (userRoles?.isSuperAdmin) {
		// 	navigate(ROUTES.TENANTS);
		// 	dispatch(setInternalUser(true))
		// } else if (userRoles?.tenantAdminInTenants?.includes(email)) {
		// 	navigate(ROUTES.CUSTOMERS_LIST);
		// } else if (userRoles?.storeAdminInStores?.includes(email)) {
		// 	navigate(ROUTES.HOME);
		// } else {
		// 	dispatch({ type: HANDLE_AUTH });
		// }
		// dispatch(setAuth0Loading(false));
	};

	useEffect(() => {
		if (userDetails && Object.keys(userDetails).length > 0) {
			handleRedirect();
		}
	}, [userDetails]);

	useEffect(() => {
		handleCallback();
	}, []);

	return (
		<div className={`dflex`}>
			{auth0Loading && !error && (
				<div className="flex items-center justify-center w-full h-screen ">
					<LoadingScreen size={60} />
				</div>
			)}
			{!auth0Loading && (
				<div className="h-screen w-screen flex justify-center items-center">
					<div>
						<p>❌ Error: {error} </p>
						<div className="flex justify-center mt-4">
							<CustomButton handleFunc={() => navigate(ROUTES.LOGIN)} buttonText="Back" />
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default AuthCallback;
